module.exports = __webpack_public_path__ + "static/solucion-eee4fc8aaa58ff508544ad43a065f332.png";